import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-notif-todolist',
  templateUrl: './notif-todolist.component.html',
  styleUrls: ['./notif-todolist.component.scss'],
})
export class NotifTodolistComponent implements OnInit {
  constructor(private modalController: ModalController
  ) { }

  ngOnInit() { }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true
    });
  }
}
